<template>
  <div v-if="genitor"
       class="card-body">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <!-- Genitor -->
      <div class="card-text w-100">
        <div class="row mb-2">
          <div class="col-6">
            <strong>Genitor:</strong> {{ genitor.nome }}
          </div>
          <div class="col-4">
            <strong>Município:</strong> {{ genitor.municipio || 'NÃO CONSTA' }}
          </div>
          <div class="col-2">
            <strong>UF:</strong> {{ genitor.uf || 'N/C' }}
          </div>
        </div>
      </div>
      <!-- Action Icons -->
      <div class="d-flex">
        <div class="ml-2"
             @click="editarGenitor()">
          <IconSvg class="icon--xs atalho-gerenciador_icon"
                   icon="pencil" />
        </div>
        <div class="ml-3"
             @click="deleteGenitor()">
          <IconSvg class="icon--xs atalho-gerenciador_icon"
                   icon="deleteIcon" />
        </div>
      </div>
    </div>

    <!-- Separator Line -->
    <hr class="my-2">

    <!-- Avos -->
    <div class="text-center">
      {{ genitor.avos }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'GenitorCard',
    props: {
      genitor: {
        type: [Object || null],
        required: true,
        default: () => null
      },
      genitorIndex: { type: Number, default: 0, required: true}
    },
    watch: {
      genitores: () => {
        console.log('Genitores atualizados:', this.genitores)
      }
    },
    methods: {
      editarGenitor () {
        this.$emit('updateGenitor', this.genitorIndex)      
      },
      deleteGenitor () {        
        this.$emit('deleteGenitor', this.genitorIndex)
      }
    }
  }
</script>

<style scoped>
.atalho-gerenciador_icon {
  cursor: pointer;
}
</style>
